import { createSlice } from "@reduxjs/toolkit";
import { MisuseFilterFormValues } from "../../types/Warehouses/warnings";

export interface TruckMisuseFiltersState {
  filterValues: MisuseFilterFormValues;
  isFilterActive: boolean;
}

const initialState: TruckMisuseFiltersState = {
  filterValues: {
    driver: undefined,
    truck: undefined,
    start: "",
    end: ""
  },
  isFilterActive: false
};

const slice = createSlice({
  name: "trainingResponsesFilters",
  initialState,
  reducers: {
    setFilterValues: (state, { payload }) => {
      state.filterValues = { ...payload };
    },
    setIsFilterActive: (state, { payload }) => {
      state.isFilterActive = payload;
    },
    clearFilters: (state) => {
      state.filterValues = {
        driver: undefined,
        truck: undefined,
        start: "",
        end: ""
      };
      state.isFilterActive = false;
    }
  }
});

export const { setFilterValues, setIsFilterActive, clearFilters } =
  slice.actions;
export default slice.reducer;
